<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue';
import {
  DialogPortal,
  DialogOverlay,
  DialogContent,
  DialogClose,
  useForwardPropsEmits,
  type DialogContentProps,
  type DialogContentEmits,
} from 'reka-ui';
import { X } from '@lucide/vue';
import { cn } from '@/lib/utils';
const props = withDefaults(
  defineProps<DialogContentProps & { class?: HTMLAttributes['class']; showClose?: boolean }>(),
  { showClose: true }
);
const emit = defineEmits<DialogContentEmits>();
const forwarded = useForwardPropsEmits(
  computed(() => {
    const { class: _class, showClose: _showClose, ...rest } = props;
    return rest;
  }),
  emit
);
</script>

<template>
  <DialogPortal>
    <DialogOverlay
      class="fixed inset-0 z-50 bg-slate-950/35 backdrop-blur-[1px] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0"
    />
    <DialogContent
      v-bind="forwarded"
      :class="
        cn(
          'fixed left-1/2 top-1/2 z-50 grid max-h-[90dvh] w-[calc(100%-2rem)] max-w-lg -translate-x-1/2 -translate-y-1/2 gap-5 overflow-y-auto rounded-lg border bg-card p-6 shadow-[0_20px_70px_-20px_rgba(15,23,42,0.25)] duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0 data-[state=open]:zoom-in-95 data-[state=closed]:zoom-out-95',
          props.class
        )
      "
    >
      <slot />
      <DialogClose
        v-if="showClose"
        class="absolute right-4 top-4 rounded-sm p-1 text-muted-foreground opacity-75 transition-opacity hover:opacity-100 focus-visible:ring-2 focus-visible:ring-ring/30"
        aria-label="Закрыть"
      >
        <X class="size-4" />
      </DialogClose>
    </DialogContent>
  </DialogPortal>
</template>
